import React from "react";
import { useSnapshot } from "valtio";
import { templateStore } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { socialMediaImages, useTemplateData } from "@constants/template";
import PhoneFrameTwo from "../../Common/PhoneFrameTwo";
import { store } from "../../Website/CoverPage/store";
import { t } from "i18next";
import { NoPicture } from "@components/Common/SvgIcons";
interface PreviewProps {
    shopData?: any; // Optional prop
}
function Preview({ shopData = {} }: PreviewProps) {
    const { selectedLanguage } = useSnapshot(store);

    const snap = useSnapshot(templateStore);
    const { getImageUrl, iuud } = useTemplateData();
    const imageUrl = getImageUrl(
        [
            "Application",
            "ChoixBoutique",
            shopData.boutique || "Default",
            "ImageDetails",
        ],
        iuud
    );

    function getNesteddValue(
        path: string[],
        field: string,
        lang: string,
        obj: any,
        isMultilingual: boolean = true
    ): any {
        try {
            let current = obj;
            for (const key of path) {
                if (current[key] === undefined) return "";
                current = current[key];
            }

            if (!current[field]) return "";

            return isMultilingual ? current[field][lang] || "" : current[field];
        } catch {
            return "";
        }
    }

    const description = React.useMemo(() => {
        return getNesteddValue(
            ["Application", "ChoixBoutique", shopData.boutique || "Default"],
            "Description", // ← swap this field name
            selectedLanguage,
            snap.template
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);
    const socialMedia = React.useMemo(() => {
        return getNesteddValue(
            ["Application", "ChoixBoutique", shopData.boutique || "Default"],
            "SocialMedia", // ← swap this field name
            selectedLanguage,
            snap.template,
            false
        );
    }, [snap.template, selectedLanguage, shopData.boutique]);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <PhoneFrameTwo>
                <div style={{ paddingBottom: "50px" }}>
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt=""
                            style={{
                                width: "100%",
                                height: "40%",
                                display: "block",
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <NoPicture height={250} width={250} />
                        </div>
                    )}

                    <h5
                        style={{
                            padding: "5px 10px ",
                            fontWeight: "bold",
                        }}
                    >
                        {t("Shop name")}
                    </h5>
                    <hr
                        style={{
                            margin: "5px 10px",
                            borderColor: "#7a7676",
                            borderStyle: "solid",
                        }}
                    />
                    <div
                        style={{
                            padding: " 0px 10px ",
                        }}
                    >
                        <p
                            style={{
                                margin: "5px",
                            }}
                        >
                            165463 km loin | $ 15 Minumum
                        </p>
                        <p
                            style={{
                                margin: "5px",
                                fontWeight: "bold",
                            }}
                        >
                            {t("On the spot")} : 15 mins
                        </p>
                    </div>

                    <hr
                        style={{
                            margin: "5px 10px",
                            borderColor: "#0e0d0d",
                            borderStyle: "solid",
                        }}
                    />
                    <div
                        style={{
                            padding: " 0px 10px ",
                            width: "100%",
                        }}
                    >
                        <h6
                            style={{
                                fontWeight: "bold",
                            }}
                        >
                            {t("About us")}
                        </h6>
                        <p
                            style={{
                                margin: "5px",
                                lineHeight: "1.2",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                            }}
                        >
                            {description}
                        </p>
                        <div
                            style={{
                                display: "flex",
                                gap: "15px",
                                flexWrap: "wrap",
                                marginTop: "10px",
                                marginBottom: "10px",
                            }}
                        >
                            {Object.entries(socialMedia).map(
                                ([platform, data]: any) =>
                                    data.Activer === true ? (
                                        <img
                                            style={{
                                                width: "30px",
                                                height: "30px",
                                            }}
                                            key={platform}
                                            src={socialMediaImages[platform]}
                                            alt={platform}
                                        />
                                    ) : null
                            )}
                        </div>
                    </div>
                    <hr
                        style={{
                            margin: "5px 10px",
                            borderColor: "#0e0d0d",
                            borderStyle: "solid",
                        }}
                    />

                    <div
                        style={{
                            padding: " 0px 10px ",
                            lineHeight: "1",
                        }}
                    >
                        <h6
                            style={{
                                fontWeight: "bold",
                            }}
                        >
                            {t("Opening time")}
                        </h6>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <strong>{t("monday")}</strong>{" "}
                            <span style={{ color: "green" }}>
                                09h00 – 18h00
                            </span>
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <strong>{t("tuesday")}</strong>{" "}
                            <span style={{ color: "green" }}>
                                09h00 – 18h00
                            </span>
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <strong>{t("wednesday")}</strong>{" "}
                            <span style={{ color: "green" }}>
                                09h00 – 18h00
                            </span>
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <strong>{t("thursday")}</strong>{" "}
                            <span style={{ color: "green" }}>
                                09h00 – 18h00
                            </span>
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <strong>{t("friday")}</strong>{" "}
                            <span style={{ color: "green" }}>
                                09h00 – 18h00
                            </span>
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <strong>{t("saturday")}</strong>{" "}
                            <span style={{ color: "green" }}>
                                10h00 – 16h00
                            </span>
                        </p>
                        <p
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            <strong>{t("sunday")}</strong>
                            <span style={{ color: "red" }}>Fermé</span>
                        </p>
                    </div>
                </div>
            </PhoneFrameTwo>
        </div>
    );
}

export default Preview;
